/**
 * All of the possible statuses that an order may have.
 */
export enum OrderStatus {
    SUBMITTED = 0,
    INPROGRESS = 1,
    DELETED = 2
}
